import { ESdChangeReason } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { KModal } from "../../../ui-kit/k-modal/k-modal";
import KuikaModalIconWrapper from "../../../ui-kit/kuika-modal-icon-wrapper/kuika-modal-icon-wrapper";
import KuikaH5 from "../../../ui-kit/typography/H5/H5";
import KuikaText from "../../../ui-kit/typography/Text/Text";

export interface IPaymentUpdateModalState {
  isSubmitButtonLoading: boolean;
}

export interface IPaymentUpdateModalProps {
  showModal?: boolean;
  closeModal?: () => void;
  paymentUpdateModalMessage?: IPaymentUpdateModalMessage;
}

interface IPaymentUpdateModalMessage {
  type: EPaymentUpdateModalType;
  message: string;
  headerMessage: string;
}

enum EPaymentUpdateModalType {
  Success = 0,
  Updated = 1,
  Error = 2,
  Cancelled = 3
}

class PaymentUpdateModal extends PureSdComponent<IPaymentUpdateModalProps & IWithSDProps, IPaymentUpdateModalState> {
  constructor(props: IPaymentUpdateModalProps & IWithSDProps) {
    super(props);
    this.state = {
      isSubmitButtonLoading: false
    };
  }

  getIcon = () => {
    const type = this.props.paymentUpdateModalMessage?.type;
    if (type === EPaymentUpdateModalType.Error) {
      return (
        <KuikaModalIconWrapper
          iconName="circle-x"
          iconType="common"
          intent="destructive"
          iconWidth={36}
          iconHeight={36}
        />
      );
    }

    if (type === EPaymentUpdateModalType.Updated) {
      return (
        <KuikaModalIconWrapper iconName="check" iconType="common" intent="success" iconWidth={36} iconHeight={36} />
      );
    }

    if (type === EPaymentUpdateModalType.Cancelled) {
      return <KuikaModalIconWrapper iconName="x" iconType="common" intent="neutral" iconWidth={36} iconHeight={36} />;
    }

    return <KuikaModalIconWrapper iconName="check" iconType="common" intent="success" iconWidth={36} iconHeight={36} />;
  };

  render() {
    const header = this.props.paymentUpdateModalMessage?.headerMessage;
    return (
      <KModal showModal={this.props.showModal} closeModal={this.props.closeModal} header={header} width={460} centered>
        <div className="kuika_delete-account" style={{ alignItems: "center", gap: 24, paddingTop: 24 }}>
          <div className="kuika_delete-account__top">{this.getIcon()}</div>
          <div className="kuika_delete-account__content" style={{ textAlign: "center" }}>
            <KuikaH5>{header}</KuikaH5>
            <KuikaText>{this.props.paymentUpdateModalMessage?.message}</KuikaText>
          </div>
        </div>
      </KModal>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const paymentUpdateModal = withSD<IPaymentUpdateModalProps>(PaymentUpdateModal);
export { paymentUpdateModal as PaymentUpdateModal };
